import { useEffect, useRef, useState } from "react";
import Navbar from "../components/Navbar";
import Swal from "sweetalert2";
import { FiCheckCircle, FiDownload, FiFilter, FiRefreshCw, FiTrash2 } from "react-icons/fi";
export default function Enrollments() {
  const [enrollments, setEnrollments] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true); // ✅ added
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

 const [visibleColumns, setVisibleColumns] =
  useState({

    name: true,
    email: true,
    phone: true,
    country: true,
    state: true,
    status: true,
    course: true,
    experience: false,
    date: true,
    action: true,

    city: true,
    mode: false,
    message: false,

  });
const filterRef = useRef(null);
const [showFilters, setShowFilters] =
  useState(false);
const fetchData = async () => {

  setLoading(true);

  try {

    const res = await fetch(
      "https://swiftintelli.com/api/getEnrollments.php"
    );

    const text = await res.text();

    console.log(
      "RAW RESPONSE:",
      text
    );

    const data =
      JSON.parse(text);

    console.log(
      "PARSED DATA:",
      data
    );

    if (Array.isArray(data)) {

      setEnrollments(data);

    } else {

      setEnrollments(
        data.enrollments || []
      );

      setContacts(
        data.contacts || []
      );

    }

  } catch (err) {

    console.error(err);

    Swal.fire({
      icon: "error",
      title: "Loading Failed",
      text: "Unable to refresh data",
    });

  } finally {

    setLoading(false);

  }

};

useEffect(() => {

  fetchData();

}, []);


  useEffect(() => {

  const handleClickOutside = (event) => {

    if (
      filterRef.current &&
      !filterRef.current.contains(
        event.target
      )
    ) {

      setShowFilters(false);

    }

  };

  document.addEventListener(
    "mousedown",
    handleClickOutside
  );

  return () => {

    document.removeEventListener(
      "mousedown",
      handleClickOutside
    );

  };

}, []);
  
const deleteEnrollment = async (id) => {

  const result = await Swal.fire({
    title: "Delete Enrollment?",
    text: "This action cannot be undone",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#dc2626",
    cancelButtonColor: "#6b7280",
    confirmButtonText: "Yes, Delete",
  });

  if (!result.isConfirmed)
    return;

  try {

    await fetch(
      "https://swiftintelli.com/api/deleteEnrollment.php",
      {
        method: "POST",

        headers: {
          "Content-Type":
            "application/json",
        },

        body: JSON.stringify({
          id,
        }),
      }
    );

    setEnrollments(
      enrollments.filter(
        (e) => e.id !== id
      )
    );

    Swal.fire({
      icon: "success",
      title: "Deleted",
      text: "Enrollment deleted successfully",
      timer: 1500,
      showConfirmButton: false,
    });

  } catch (err) {

    console.error(err);

    Swal.fire({
      icon: "error",
      title: "Delete Failed",
      text: "Unable to delete enrollment",
    });
  }
};

const deleteContact = async (id) => {

  const result = await Swal.fire({
    title: "Delete Contact?",
    text: "This action cannot be undone",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#dc2626",
    cancelButtonColor: "#6b7280",
    confirmButtonText: "Yes, Delete",
  });

  if (!result.isConfirmed)
    return;

  try {

    await fetch(
      "https://swiftintelli.com/api/deleteContact.php",
      {
        method: "POST",

        headers: {
          "Content-Type":
            "application/json",
        },

        body: JSON.stringify({
          id,
        }),
      }
    );

    setContacts(
      contacts.filter(
        (c) => c.id !== id
      )
    );

    Swal.fire({
      icon: "success",
      title: "Deleted",
      text: "Contact deleted successfully",
      timer: 1500,
      showConfirmButton: false,
    });

  } catch (err) {

    console.error(err);

    Swal.fire({
      icon: "error",
      title: "Delete Failed",
      text: "Unable to delete contact",
    });
  }
};


const exportCSV = () => {

  const headers = [
    "Name",
    "Email",
    "Phone",
    "Country",
    "State",
    "City",
    "Status",
    "Course",
    "Experience",
    "Mode",
    "Date",
  ];

  const rows = enrollments.map((e) => [
    e.name,
    e.email,
    e.phone,
    e.country,
    e.state_name,
    e.city,
    e.status,
    e.course_name,
    e.experience,
    e.mode_of_learning,
    e.created_at,
  ]);

  let csvContent =
    "data:text/csv;charset=utf-8," +
    [headers, ...rows]
      .map((r) => r.join(","))
      .join("\n");

  const encodedUri =
    encodeURI(csvContent);

  const link =
    document.createElement("a");

  link.setAttribute(
    "href",
    encodedUri
  );

  link.setAttribute(
    "download",
    "swiftintelli_enrollments.csv"
  );

  document.body.appendChild(link);

  link.click();

};


/* PAGINATION */

const totalEnrollments =
  enrollments.length;

const totalPages =
  Math.ceil(
    totalEnrollments / rowsPerPage
  );

const startIndex =
  (currentPage - 1) * rowsPerPage;

const endIndex =
  startIndex + rowsPerPage;

const currentEnrollments =
  enrollments.slice(
    startIndex,
    endIndex
  );

  const toggleColumn = (key) => {

  setVisibleColumns((prev) => ({

    ...prev,

    [key]: !prev[key],

  }));

};

const toggleAllColumns = (value) => {

  const updated = {};

  Object.keys(
    visibleColumns
  ).forEach((key) => {

    updated[key] = value;

  });

  setVisibleColumns(updated);

};


  return (
    <div className="si-root">
      <Navbar />

      <div className="enroll-page">
        {/* ================= ENROLLMENTS ================= */}
       

        {loading ? (
          <p>Loading...</p>
        ) : (
        <div className="table-wrapper">

  <div className="table-top">

    <h2>
      Enrolled Students
    </h2>
<div className="table-count">

  Total Enrollments:
  <span>
    {totalEnrollments}
  </span>

</div>

<div className="table-actions">

<div className="icon-tooltip-wrapper">

    <FiRefreshCw className={`refresh-icon ${
      loading ? "spinning" : ""
    }`}
    onClick={fetchData} />
 

  <span className="custom-tooltip">
    Refresh Data
  </span>

</div>

 <div className="icon-tooltip-wrapper">
  <FiFilter
    className="filter-icon"
    onClick={() =>
      setShowFilters(!showFilters)
    }
    title="Filter"
  />
  <span className="custom-tooltip">
    Filters
  </span>
  </div>

  <div className="icon-tooltip-wrapper">
  
  <FiDownload
    className="export-icon"
    onClick={exportCSV}
    title="Download CSV"
  />
   <span className="custom-tooltip">
    Download CSV
  </span>

</div>

</div>
   
  </div>
{showFilters && (

  <div
    className="filter-dropdown"
    ref={filterRef}
  >

    <div className="filter-actions">

      <button
        onClick={() =>
          toggleAllColumns(true)
        }
      >
        Select All
      </button>

      <button
        onClick={() =>
          toggleAllColumns(false)
        }
      >
        Clear All
      </button>

    </div>

    {Object.keys(
      visibleColumns
    ).map((key) => (

      <label
        key={key}
        className="filter-checkbox"
      >

        <input
          type="checkbox"
          checked={
            visibleColumns[key]
          }
          onChange={() =>
            toggleColumn(key)
          }
        />

        {key
          .replace("_", " ")
          .replace(
            /\b\w/g,
            (c) =>
              c.toUpperCase()
          )}

      </label>

    ))}

  </div>

)}

  <div className="table-scroll">

    <table className="enroll-table">

      <thead>

       <tr>

  {visibleColumns.name && (
    <th>Name</th>
  )}

  {visibleColumns.email && visibleColumns.phone && (
    <th>Email / Phone</th>
  )}

 

  {visibleColumns.country && (
    <th>Country</th>
  )}

  {visibleColumns.state && visibleColumns.city && (
    <th>State / City</th>
  )}

 

  {visibleColumns.status && (
    <th>Status</th>
  )}

  {visibleColumns.course && (
    <th>Course</th>
  )}

  {visibleColumns.experience && (
    <th>Experience</th>
  )}

  {visibleColumns.mode && (
    <th>Mode</th>
  )}

  {visibleColumns.message && (
    <th>Message</th>
  )}

  {visibleColumns.date && (
    <th>Date</th>
  )}

  {visibleColumns.action && (
    <th>Action</th>
  )}

</tr>
      </thead>

      <tbody>

        {currentEnrollments.map((e) => (

          <tr key={e.id}>

  {visibleColumns.name && (
    <td>{e.name}</td>
  )}

  {visibleColumns.email && visibleColumns.phone && (

  <td className="table-email">

    <div className="email-cell">

      <span>
        {e.email}
      </span>

      {e.email_verified == 1 && (

       <div className="icon-tooltip-wrapper verified-badge">

          <FiCheckCircle />

         <span className="custom-tooltip">
    Verified Email
  </span>

        </div>

      )}

    </div>
{e.phone}
  </td>

)}

  

  {visibleColumns.country && (
    <td>{e.country}</td>
  )}

  {visibleColumns.state && visibleColumns.city && (
    <td>{e.state_name} <br/>
     {e.city}</td>
  )}


  {visibleColumns.status && (
    <td>{e.status}</td>
  )}

  {visibleColumns.course && (
    <td className="table-course">
      {e.course_name}
    </td>
  )}

  {visibleColumns.experience && (
    <td>{e.experience}</td>
  )}
  
{visibleColumns.mode && (
  <td>{e.mode_of_learning}</td>
)}

{visibleColumns.message && (
  <td className="table-message">
    {e.message || "-"}
  </td>
)}


  {visibleColumns.date && (
    <td>{e.created_at}</td>
  )}

  {visibleColumns.action && (
    <td>
      <div className="icon-tooltip-wrapper">
      <FiTrash2
        className="delete-icon"
        onClick={() =>
          deleteEnrollment(e.id)
        }
      />
       <span className="custom-tooltip">
    Delete Enrollment
  </span>
</div>
    </td>
  )}

</tr>

        ))}

      </tbody>

    </table>

  </div>
<div className="pagination">

  <button
    disabled={currentPage === 1}
    onClick={() =>
      setCurrentPage(
        currentPage - 1
      )
    }
  >
    Prev
  </button>

  {[...Array(totalPages)].map((_, i) => (

    <button
      key={i}
      className={
        currentPage === i + 1
          ? "active-page"
          : ""
      }
      onClick={() =>
        setCurrentPage(i + 1)
      }
    >
      {i + 1}
    </button>

  ))}

  <button
    disabled={
      currentPage === totalPages
    }
    onClick={() =>
      setCurrentPage(
        currentPage + 1
      )
    }
  >
    Next
  </button>

</div>
</div>




//           <div className="card-grid">

//   {enrollments.length > 0 ? (

//     enrollments.map((e, i) => (

//       <div
//         key={i}
//         className="card"
//       >
//         <button
//     className="delete-btn top-delete"
//     onClick={() =>
//       deleteEnrollment(e.id)
//     }
//   >
//     ✕
//   </button>
       

//         {/* NAME */}

//         <h3 className="card-name">

//           {e.name}

//         </h3>

//         {/* EMAIL */}

//         {/* EMAIL */}

// <div className="email-row">

//   <p className="card-email">
//     {e.email}
//   </p>

//   {e.email_verified == 1 && (

//     <div className="verified-wrapper">

//       <img
//         src="https://cdn-icons-png.flaticon.com/512/190/190411.png"
//         alt="verified"
//         className="verified-icon"
//       />

//       <span className="verified-tooltip">
//         Verified
//       </span>

//     </div>

//   )}

// </div>

//         {/* DETAILS */}

//         <div className="card-details">

//           <p>
//             <b>Phone:</b> {e.phone}
//           </p>

//           <p>
//             <b>Country:</b>{" "}
//             {e.country || "N/A"}
//           </p>

//           <p>
//             <b>State:</b>{" "}
//             {e.state_name || "N/A"}
//           </p>

//           <p>
//             <b>City:</b>{" "}
//             {e.city || "N/A"}
//           </p>

//           <p>
//             <b>Status:</b>{" "}
//             {e.status || "N/A"}
//           </p>

//           <p>
//             <b>Course:</b>{" "}
//             {e.course_name || "N/A"}
//           </p>

//           <p>
//             <b>Experience:</b>{" "}
//             {e.experience || "N/A"}
//           </p>

//         </div>

//         {/* MESSAGE */}

//         <div className="message-box">

//           <b>Message:</b>

//           <p>
//             {e.message || "-"}
//           </p>

//         </div>

//         {/* DATE */}

//         <p className="card-date">
//           {e.created_at}
//         </p>

//       </div>
      

//     ))

//   ) : (

//     <p>No enrollments found</p>

//   )}

// </div>
        )}

        {/* ================= CONTACTS ================= */}
        <h2>Contact Requests</h2>

        <div className="card-grid">

  {contacts.length > 0 ? (

    contacts.map((c, i) => (

      <div
        key={i}
        className="card"
      >
        <button
  className="delete-btn top-delete"
  onClick={() =>
    deleteContact(c.id)
  }
>
  ✕
</button>

        {/* NAME */}

        <h3 className="card-name">
          {c.name}
        </h3>

        {/* EMAIL */}

        <p className="card-email">
          {c.email}
        </p>

        {/* DETAILS */}

        <div className="card-details">

          <p>
            <b>Phone Code:</b>{" "}
            {c.phone_code || "N/A"}
          </p>

          <p>
            <b>Phone:</b>{" "}
            {c.phone || "N/A"}
          </p>

          <p>
            <b>Country:</b>{" "}
            {c.country_name || c.country || "N/A"}
          </p>

          <p>
            <b>State:</b>{" "}
            {c.state || "N/A"}
          </p>

          <p>
            <b>City:</b>{" "}
            {c.city || "N/A"}
          </p>

          <p>
            <b>Status:</b>{" "}
            {c.status || "N/A"}
          </p>

          <p>
            <b>Course:</b>{" "}
            {c.course || "N/A"}
          </p>

          <p>
            <b>Experience:</b>{" "}
            {c.experience || "N/A"}
          </p>

        </div>

        {/* MESSAGE */}

        <div className="message-box">

          <b>Message:</b>

          <p>
            {c.message || "-"}
          </p>

        </div>

        {/* DATE */}

        <p className="card-date">
          {c.created_at}
        </p>

        {/* DELETE BUTTON */}

       

      </div>

    ))

  ) : (

    <p>No contact requests</p>

  )}

</div>
</div>
</div>
  );
}
